import React from 'react';
import styled from 'styled-components';
import { Panel, Text, Box } from '@tidbits/react-tidbits';
import IconTemplate, { IconType } from '@ui-components/icon-template';

const hotkeys: HotKeyDescription[] = [
    {
        icon: 'wKey',
        description: 'From the worklist, navigate to any task by pressing the W key and enter the workflow ID.'
    },
    {
        icon: 'asteriskKey',
        description: 'From the text editor, press * to show the unicode palette.'
    },
    {
        icon: 'sKey',
        description: 'From the worklist, navigate directly to the search input by pressing the S key.'
    }
];

const HotKeyDescriptionContainer = styled.div`
  padding-bottom: 20px;
  display: flex; 
  display: -webkit-flex;
  -webkit-flex-direction: row;

`

const DescriptionContainer = styled.div`
  margin-left: 10px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
`

const IconContainer = styled.div`
  width: 30px;
`

const TitleContainer = styled(Box)`
  padding-bottom: 15px;
`

const ContentContainer = styled(Box)`
  padding-top: 10px;
`

interface HotKeyDescription {
    icon: IconType;
    description: string;
}

export const HotKeys = () => {
  return (
    <Panel height={'100%'}>
      <TitleContainer>
          <Text sb="spacer20" textStyle="h3Emph">
            Hot Keys Guide
          </Text>
      </TitleContainer>
      <ContentContainer>
        {
          hotkeys.map(({ icon, description }, index)  => {
            return (
              <HotKeyDescriptionContainer key={index}>
                <IconContainer>
                  <IconTemplate name={icon}/>
                </IconContainer>
                <DescriptionContainer>
                  <Text>
                    { description }
                  </Text>
                </DescriptionContainer>
              </HotKeyDescriptionContainer>
            )
          })
        }
      </ContentContainer>
    </Panel>
  )
}
